import { Directive, Input, OnInit, ElementRef, Renderer2, TemplateRef, ViewContainerRef,ViewRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { PermissionsService } from '@app/core/services/permissions.service';
import { User } from '@app/shared/models/user';

@Directive({
  selector: '[permissionMenu]'
})
export class PermissionMenuDirective implements OnInit {
  private permission$: Subscription;
  private count:number = 0;
  private currentIdx = 0;
  private permissions:any[];
  private viewRef:ViewRef;
  private _departments:any;
  private _user:User;

  @Input() set permissionMenu(value: any) {
    this.count = 0;
    this.currentIdx = 0;
    this.permissions = value.permissions;
    //this._departments = value.departments?value.departments.split(','):[];
    this._user = value.user;

    this.applyPermission(this.permissions[this.currentIdx]);
  }
  @Input() set departments(value:any){
    this._departments = value;
  }
  @Input() set user(value:User){
    this._user = value;
  }

  constructor(private el: ElementRef,private renderer: Renderer2,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private workflowEvents:PermissionsService) {

  }

  ngOnInit(): void {
    this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
  }

  private applyPermission(value: string | string[]): void {

    this.permission$ = this.workflowEvents.checkAuthorization(value)
      .subscribe(authorized => {
        ++this.currentIdx;

        if (authorized) {
          ++this.count;
        }
        if(this.currentIdx < this.permissions.length){
          this.applyPermission(this.permissions[this.currentIdx])
        }else{
          setTimeout(_ => this.setDisplay());
        }
      });
  }
  private checkDepartments():boolean{
    let result = true;
    // const user:User = this._user;
    // const departments = this._departments;
    // if(this._departments && this._user && this._user.departments){
    //   user.departments.map(val => {
    //     console.log(val," : department.includes",departments.includes(val))
    //     if(departments.includes(val)){
    //       result = true;
    //     }
    //   })
    // }else{
    //   result = true;
    // }

    return result;
  }
  private setDisplay():void{
    const elem = this.viewContainer.element.nativeElement.parentNode;
    const isTeam = this.checkDepartments();
    if(!this.count){
      const btn = elem.querySelector('.menu-btn');
      if(btn)btn.parentNode.removeChild(btn);
    }

  }

  ngOnDestroy(): void {
    if(this.permission$)
      this.permission$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/permission-menu.directive.ts